exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".canvas_layout[data-v-6a91a954] {\n  width: 100%;\n  height: 100%;\n}", ""]);

// exports
